import * as ActionTypes from './actionTypes';
import {
  FormSubsection, FormState, FormSubsectionData, FormStateSubsectionsKeys
} from './types';

export interface UpdateSubsectionRequestAction {
  type: typeof ActionTypes.UPDATE_SUBSECTION_REQUEST
  payload: {
    subsectionKey: FormStateSubsectionsKeys
    data: FormSubsectionData
    validateSubsectionKeys: string[]
  }
}
export const updateSubsectionRequest = (
  subsectionKey: FormStateSubsectionsKeys,
  data: FormSubsectionData = {},
  validateSubsectionKeys: string[] = []
): UpdateSubsectionRequestAction => ({
  type: ActionTypes.UPDATE_SUBSECTION_REQUEST,
  payload: {
    subsectionKey,
    data,
    validateSubsectionKeys: [subsectionKey, ...validateSubsectionKeys],
  },
});

export interface SubsectionValidation {
  key: FormStateSubsectionsKeys
  errors: FormSubsection['errors']
  formErrors: FormSubsection['formErrors']
  complete: FormSubsection['complete']
}

export interface UpdateCurrentScrollValueAction {
  type: typeof ActionTypes.UPDATE_CURRENT_SCROLL_VALUE
  payload: {
    currentScrollValue: number | null
  }
}

export const updateCurrentScrollValue = (
  currentScrollValue: number | null
): UpdateCurrentScrollValueAction => ({
  type: ActionTypes.UPDATE_CURRENT_SCROLL_VALUE,
  payload: {
    currentScrollValue
  },
});

export interface UpdateSubsectionSuccessAction {
  type: typeof ActionTypes.UPDATE_SUBSECTION_SUCCESS
  payload: {
    subsectionValidations: SubsectionValidation[]
    data: FormSubsectionData
    subsectionKey: FormStateSubsectionsKeys
  }
}

export const updateSubsectionSuccess = (
  subsectionKey: FormStateSubsectionsKeys,
  data: FormSubsectionData,
  subsectionValidations: SubsectionValidation[]
): UpdateSubsectionSuccessAction => ({
  type: ActionTypes.UPDATE_SUBSECTION_SUCCESS,
  payload: {
    subsectionValidations,
    subsectionKey,
    data,
  },
});

export interface UpdateSubsectionErrorsAction {
  type: typeof ActionTypes.UPDATE_SUBSECTION_ERRORS
  payload: {
    subsectionKey: string
    errors: string[]
  }
}
export const updateSubsectionErrors = (
  subsectionKey: string,
  errors: string[] = []
): UpdateSubsectionErrorsAction => ({
  type: ActionTypes.UPDATE_SUBSECTION_ERRORS,
  payload: {
    subsectionKey,
    errors,
  },
});

export interface UpdateSubsectionCompleteAction {
  type: typeof ActionTypes.UPDATE_SUBSECTION_COMPLETE
  payload: {
    subsectionKey: string
    complete: boolean
  }
}
export const updateSubsectionComplete = (
  subsectionKey: string,
  complete: boolean
): UpdateSubsectionCompleteAction => ({
  type: ActionTypes.UPDATE_SUBSECTION_COMPLETE,
  payload: {
    subsectionKey,
    complete,
  },
});

export interface ValidateFormAction {
  type: typeof ActionTypes.VALIDATE_FORM
}
export const validateForm = (): ValidateFormAction => ({
  type: ActionTypes.VALIDATE_FORM,
});

export interface ValidateFormSuccessAction {
  type: typeof ActionTypes.VALIDATE_FORM_SUCCESS
  payload: FormState
}
export const validateFormSuccess = (newState: FormState): ValidateFormSuccessAction => ({
  type: ActionTypes.VALIDATE_FORM_SUCCESS,
  payload: newState,
});

export interface ValidateFormFailureAction {
  type: typeof ActionTypes.VALIDATE_FORM_FAILURE
}
export const validateFormFailure = (): ValidateFormFailureAction => ({
  type: ActionTypes.VALIDATE_FORM_FAILURE,
});

export type FormActions =
  | ValidateFormAction
  | ValidateFormSuccessAction
  | ValidateFormFailureAction
  | UpdateSubsectionSuccessAction
  | UpdateSubsectionCompleteAction
  | UpdateSubsectionErrorsAction
  | UpdateCurrentScrollValueAction
